// Redesign 2026 – galerie s lightboxem (includes/template-parts/redesign/gallery.php, byt/detail.php).
// Dlaždice jsou <button data-rd-gallery-item data-full data-alt>; po kliku se otevře překryvná vrstva
// s listováním (‹ ›, šipky), popiskem, počítadlem a zavřením (✕, Escape, klik mimo obrázek).
// Vrstva se vytváří až při prvním otevření a přidává k <body> s kořenem `.rd`, aby na ni platily styly.

function el(tag, className, text) {
  const node = document.createElement(tag);
  if (className) {
    node.className = className;
  }
  if (text !== undefined) {
    node.textContent = text;
  }
  return node;
}

function createLightbox() {
  const box = el('div', 'rd rd-lightbox');
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Galerie fotografií');
  box.hidden = true;

  const head = el('div', 'rd-lightbox__head');
  const caption = el('span', 'rd-lightbox__caption');
  const meta = el('span', 'rd-lightbox__meta');
  const counter = el('span', 'rd-lightbox__counter');
  const close = el('button', 'rd-lightbox__close', 'Zavřít ✕');
  close.type = 'button';
  meta.append(counter, close);
  head.append(caption, meta);

  const body = el('div', 'rd-lightbox__body');
  const prev = el('button', 'rd-lightbox__nav rd-lightbox__nav--prev', '‹');
  prev.type = 'button';
  prev.setAttribute('aria-label', 'Předchozí fotografie');
  const next = el('button', 'rd-lightbox__nav rd-lightbox__nav--next', '›');
  next.type = 'button';
  next.setAttribute('aria-label', 'Další fotografie');
  const img = el('img', 'rd-lightbox__img');
  body.append(prev, img, next);

  box.append(head, body);
  document.body.appendChild(box);

  return { box, caption, counter, close, prev, next, img };
}

export default function initRedesignGallery() {
  const galleries = Array.from(document.querySelectorAll('[data-rd-gallery]'));
  if (!galleries.length) {
    return;
  }

  let ui = null;
  let items = [];
  let index = 0;
  let opener = null;

  function show(i) {
    index = (i + items.length) % items.length;
    const item = items[index];
    ui.img.src = item.full;
    ui.img.alt = item.alt;
    ui.caption.textContent = item.alt;
    ui.counter.textContent = `${index + 1} / ${items.length}`;
  }

  function closeBox() {
    if (!ui || ui.box.hidden) {
      return;
    }
    ui.box.hidden = true;
    document.documentElement.classList.remove('rd-lightbox-open');
    if (opener) {
      opener.focus({ preventScroll: true });
    }
  }

  function openBox(list, i, button) {
    if (!ui) {
      ui = createLightbox();
      ui.close.addEventListener('click', closeBox);
      ui.prev.addEventListener('click', () => show(index - 1));
      ui.next.addEventListener('click', () => show(index + 1));
      ui.box.addEventListener('click', (event) => {
        if (event.target === ui.box || event.target.classList.contains('rd-lightbox__body')) {
          closeBox();
        }
      });
    }
    items = list;
    opener = button;
    show(i);
    ui.box.hidden = false;
    document.documentElement.classList.add('rd-lightbox-open');
    ui.close.focus({ preventScroll: true });
  }

  galleries.forEach((gallery) => {
    // vnořená galerie (detail bytu EFI Palace: půdorysy uvnitř galerie fotek) má vlastní listování
    const own = (node) => node.closest('[data-rd-gallery]') === gallery;
    const buttons = Array.from(gallery.querySelectorAll('[data-rd-gallery-item]')).filter(own);
    const list = buttons.map((button) => ({
      full: button.dataset.full || (button.querySelector('img') || {}).src || '',
      alt: button.dataset.alt || '',
    }));
    buttons.forEach((button, i) => {
      button.addEventListener('click', () => openBox(list, i, button));
    });
    // mimo dlaždice: tlačítko s data-rd-gallery-open="<pořadí>" otevře galerii na dané fotce
    // (hlavní fotka na stránce bytu, byt/detail.php) a do listování se nepočítá
    Array.from(gallery.querySelectorAll('[data-rd-gallery-open]')).filter(own).forEach((button) => {
      button.addEventListener('click', () => {
        if (list.length) {
          openBox(list, Number(button.dataset.rdGalleryOpen) || 0, button);
        }
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (!ui || ui.box.hidden) {
      return;
    }
    if (event.key === 'Escape') {
      closeBox();
    } else if (event.key === 'ArrowLeft') {
      show(index - 1);
    } else if (event.key === 'ArrowRight') {
      show(index + 1);
    }
  });
}
